module.exports = __webpack_public_path__ + "media/src/images/landing/leave-c9325563d92f21a71e2c5020506ee0b1.svg";